
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkharadi() {



    const cardData =
    {
        keyword: 'Cab Service in Kharadi',
        heading: 'Platinum24 Cabs: Cab Service in Kharadi',
        headingDescription: ' Platinum24 Cabs provides trusted Cab Service in Kharadi, ideal for professionals, families, and students seeking reliable local and outstation travel. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable ride for city commutes, airport transfers, corporate trips, or weekend getaways. With professional chauffeurs, on-time pickups, and transparent pricing, we make every journey smooth and stress-free. Whether you’re heading to Pune Airport, Magarpatta, Hinjewadi, or an outstation destination, Platinum24 Cabs guarantees safe, affordable, and 24/7 cab services in and around Kharadi.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the political seat of the Maratha Empire, it showcases grand gates, fountains, and gardens. Although partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show brings history alive. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Indo-Italian architecture. It gained prominence during the freedom struggle as Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. The palace now houses a museum with Gandhi’s personal items and photos. Surrounded by sprawling gardens, it offers peace and reflection. It is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s inspirational historic site."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The hill fort offers trekking trails with scenic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon makes it lush with mist and waterfalls. Local villagers serve traditional pithla-bhakri at the top. Sinhagad is Pune’s blend of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The magnificent idol is adorned with gold and precious ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also renowned for charitable and cultural activities. Devotees visit throughout the year for blessings. Dagdusheth Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. The temple features huge stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it provides peace and spirituality amidst urban life. Its ancient carvings reflect early Indian craftsmanship. Evening prayers add to its mystical charm. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include sculptures, ornaments, musical instruments, and daily-life antiques. The recreated Mastani Mahal is the museum’s highlight. Students, historians, and tourists find it educational and fascinating. It preserves centuries of Indian art and traditions. The museum is Pune’s cultural treasure trove."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop Parvati Temple is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. The climb of 103 steps is both devotional and adventurous. Smaller shrines and museums surround the main temple. Sunrise and sunset views are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts visitors from all over the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and tranquil halls enhance the experience. It is ideal for peace, rejuvenation, and self-discovery. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns create a serene environment. Families enjoy peaceful strolls, picnics, and photography here. The garden represents Indo-Japanese friendship. Seasonal flowers make it colorful year-round. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city and offers picturesque views of hills and flowing waters. During monsoon, the overflowing dam is a spectacular sight. Vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



   "services": [
    {
      "name": "Cab Service Kharadi Pune",
      "description": "Get professional and punctual cab service in Kharadi Pune with a fleet of sanitized vehicles and trained drivers. Whether it's a short trip within the city or a long outstation journey, our cabs provide maximum comfort, safety, and convenience. Ideal for residents, IT professionals, and travelers looking for reliable transportation in Kharadi."
    },
    {
      "name": "Kharadi Taxi Service",
      "description": "Kharadi taxi service offers convenient travel solutions around the clock. From daily commutes to emergency pickups, our taxis are available 24/7. Our service is powered by skilled drivers, modern vehicles, and GPS-enabled navigation for secure and timely travel across Pune."
    },
    {
      "name": "Taxi Booking in Kharadi Pune",
      "description": "Book a taxi in Kharadi quickly through our user-friendly app, website, or by calling our helpline. Get instant confirmation, fare estimates, and live tracking features. Whether it’s an early morning office ride or a late-night drop, we ensure availability when you need it most."
    },
    {
      "name": "Local Cab Kharadi",
      "description": "Our local cab service in Kharadi is perfect for daily errands, office visits, shopping runs, and school pickups. Get short-distance city rides at economical rates with experienced drivers who know the area inside out. Book instantly or schedule in advance."
    },
    {
      "name": "Kharadi Cab Rental",
      "description": "Need a cab for a few hours or a full day? Our Kharadi cab rental service offers hourly and daily packages for city rides, tours, or business meetings. Pick your preferred car type and enjoy chauffeur-driven rides without the hassle of owning or maintaining a car."
    },
    {
      "name": "Affordable Taxi Kharadi",
      "description": "Looking for budget-friendly taxi rides in Kharadi? We provide transparent pricing with no hidden charges. Get the best rates for both short and long-distance trips, and enjoy the balance of affordability and comfort in every ride."
    },
    {
      "name": "Kharadi Cab Hire",
      "description": "Hire a cab in Kharadi for local trips, intercity travel, or custom packages. Our cab hire services include luxury, economy, and SUV options. Perfect for weddings, events, or professional needs with 100% customer support and flexible booking options."
    },
    {
      "name": "Kharadi Taxi Booking Online",
      "description": "With our online taxi booking in Kharadi, you can reserve a cab in under 60 seconds. Real-time car availability, instant confirmation, digital payments, and live driver updates make it easy and secure to manage all your travel plans online."
    },
    {
      "name": "Reliable Cab Service Kharadi",
      "description": "Our Kharadi cab service is trusted for being on time, well-maintained, and secure. All drivers are verified and undergo regular training. Whether it’s a quick city run or a full-day booking, we ensure hassle-free and pleasant experiences for every customer."
    },
    {
      "name": "Kharadi Local Taxi",
      "description": "Get a local taxi in Kharadi for short rides, office drops, school runs, or market visits. Our cabs are clean, fast, and available at a moment’s notice. Ideal for solo riders, senior citizens, and anyone looking for trustworthy travel in and around the neighborhood."
    },
    {
      "name": "Kharadi Airport Taxi",
      "description": "Book your airport taxi from Kharadi to Pune Airport or vice versa. Our airport transfers are punctual, professional, and include free wait time and luggage assistance. Flights delayed or arriving early? Don’t worry — we track your flight and adjust the pickup time accordingly."
    },
    {
      "name": "Kharadi Outstation Taxi",
      "description": "Travel from Kharadi to nearby destinations like Mumbai, Lonavala, Mahabaleshwar, or Goa with our outstation taxi service. Choose one-way or round-trip options and enjoy stress-free intercity travel with experienced drivers and comfortable vehicles."
    },
    {
      "name": "Kharadi Corporate Cab Service",
      "description": "Our corporate cab solutions in Kharadi serve businesses with employee transportation, executive travel, and event logistics. We provide monthly billing, dedicated support, and an elite fleet of well-maintained vehicles for seamless corporate mobility."
    },
    {
      "name": "Kharadi Night Taxi Service",
      "description": "Need to travel late at night? Our night taxi service in Kharadi is designed for safety and reliability. With trained night-shift drivers, emergency support, and 24x7 availability, we ensure you get home or to your destination securely even during odd hours."
    },
    {
      "name": "Kharadi Cab for Events",
      "description": "Hosting a wedding, business meet, or private party in Kharadi? Book event-specific cabs for guests, VIPs, or staff. Get customized packages with multiple vehicles, fixed or hourly pricing, and coordination support to ensure smooth event transportation."
    }
  ],
  "tableData": [
    ["Cab Service Kharadi Pune", "Kharadi Taxi Service"],
    ["Taxi Booking in Kharadi Pune", "Local Cab Kharadi"],
    ["Kharadi Cab Rental", "Affordable Taxi Kharadi"],
    ["Kharadi Cab Hire", "Kharadi Taxi Booking Online"],
    ["Reliable Cab Service Kharadi", "Kharadi Local Taxi"],
    ["Kharadi Airport Taxi", "Kharadi Outstation Taxi"],
    ["Kharadi Corporate Cab Service", "Kharadi Night Taxi Service"],
    ["Kharadi Cab for Events", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Reliable Cab Service in Kharadi, Pune",
      "WhyChoosedescription": "Platinum24 Cabs provides prompt and professional cab services in Kharadi for local and outstation travel."
    },
    {
      "WhyChooseheading": "Quick Pickup with Nearby Cabs Always Available",
      "WhyChoosedescription": "Our fleet is actively stationed near Kharadi, ensuring fast and efficient pickups at any time."
    },
    {
      "WhyChooseheading": "Affordable Rates for Local and Long-Distance Rides",
      "WhyChoosedescription": "Enjoy budget-friendly fares for daily commutes, airport transfers, or weekend getaways."
    },
    {
      "WhyChooseheading": "Clean, AC Cabs for a Comfortable Travel Experience",
      "WhyChoosedescription": "Travel in well-maintained and sanitized vehicles, ensuring a safe and pleasant ride."
    },
    {
      "WhyChooseheading": "Professional Drivers with Route Expertise",
      "WhyChoosedescription": "Our experienced drivers know Kharadi and surrounding areas well, ensuring smooth navigation and timely drop-offs."
    },
    {
      "WhyChooseheading": "24/7 Cab Availability for All Your Travel Needs",
      "WhyChoosedescription": "Book a cab anytime—day or night—with our always-on cab service in Kharadi."
    },
    {
      "WhyChooseheading": "Flexible Booking Options: One-Way, Round Trip, or Hourly",
      "WhyChoosedescription": "Choose the rental type that fits your schedule and purpose of travel."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
      "WhyChoosedescription": "Get fixed, all-inclusive fares with no last-minute surprises—fuel, tolls, and driver fees included."
    }
  ]


























    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services in Kharadi?',
        answer: 'Yes, Platinum24 Cabs offers reliable and convenient cab services within Kharadi for all your local travel needs.',
    },
    {
        question: 'How can I book a cab service in Kharadi with Platinum24 Cabs?',
        answer: 'You can easily book a cab in Kharadi through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for cab service in Kharadi?',
        answer: 'We provide a variety of vehicles including sedans, SUVs, and premium cars to suit your preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for local travel within Kharadi?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Kharadi area.',
    },
    {
        question: 'Can I book a cab for hourly or daily use in Kharadi?',
        answer: 'Absolutely! We offer flexible hourly and daily rental packages tailored to your schedule and travel needs.',
    },
    {
        question: 'What is included in the fare for cab services in Kharadi?',
        answer: 'The fare covers vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Kharadi?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Kharadi for your convenience.',
    },
    {
        question: 'Are safety measures followed for cab services in Kharadi?',
        answer: 'All vehicles are regularly sanitized, and our drivers adhere to strict safety protocols to ensure your protection.',
    },
    {
        question: 'Is corporate cab service available in Kharadi?',
        answer: 'Yes, Platinum24 Cabs provides customized corporate cab services in Kharadi with priority support and flexible billing options.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sameer Kulkarni',
        feedback: 'The cab service in Kharadi by Platinum24 Cabs was prompt and reliable. The driver was courteous and professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Deshmukh',
        feedback: 'Booking a cab in Kharadi was seamless and hassle-free. Highly recommend Platinum24 Cabs for local travel.',
        rating: 5,
    },
];








































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const cabServiceKharadiSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kharadi",
  "image": "https://www.platinum24cab.com/assets/images/kharadi-cab-service.jpg",
  "description": "Book professional cab service in Kharadi, Pune with Platinum24 Cabs. Reliable airport, local, and outstation taxi options at affordable prices with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "300",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/cab-service-kharadi"
  }
};






    return (
        <div>
<Helmet>
  <title>Cab Service in Kharadi | Local & Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book professional cab service in Kharadi, Pune with Platinum24 Cabs. Reliable airport, local, and outstation taxi options at affordable prices with experienced drivers."
  />
  <meta
    name="keywords"
    content="Cab Service Kharadi Pune, Kharadi Taxi Service, Taxi Booking in Kharadi Pune, Local Cab Kharadi, Kharadi Cab Rental, Affordable Taxi Kharadi, Kharadi Cab Hire, Kharadi Taxi Booking Online, Reliable Cab Service Kharadi, Kharadi Local Taxi, Kharadi Airport Taxi, Kharadi Outstation Taxi, Kharadi Corporate Cab Service, Kharadi Night Taxi Service, Kharadi Cab for Events"
  />
  <script type="application/ld+json">
    {JSON.stringify(cabServiceKharadiSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinkharadi;